const KEY = "cyborg.characters.v1";
const ROLL_KEY = "cyborg.rolls.v1";
const ENCOUNTER_KEY = "cyborg.encounters.v1";
const FOE_KEY = "cyborg.foes.v1";

export function loadLocalCharacters() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function saveLocalCharacters(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function upsertLocalCharacter(char) {
  const list = loadLocalCharacters();
  const idx = list.findIndex((c) => c.id === char.id);
  const now = new Date().toISOString();
  const merged = { ...char, updated_at: now };
  if (idx >= 0) list[idx] = merged;
  else list.push({ ...merged, created_at: now });
  saveLocalCharacters(list);
  return merged;
}

export function deleteLocalCharacter(id) {
  const list = loadLocalCharacters().filter((c) => c.id !== id);
  saveLocalCharacters(list);
}

export function loadLocalRolls() {
  try {
    const raw = localStorage.getItem(ROLL_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function pushLocalRoll(roll) {
  const list = loadLocalRolls();
  list.unshift(roll);
  localStorage.setItem(ROLL_KEY, JSON.stringify(list.slice(0, 100)));
}

// ---------- Encounters (Combat Arena saves) ----------
export function loadLocalEncounters() {
  try {
    const raw = localStorage.getItem(ENCOUNTER_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function saveLocalEncounter(enc) {
  const list = loadLocalEncounters();
  const now = new Date().toISOString();
  const idx = list.findIndex((e) => e.id === enc.id);
  const merged = { ...enc, updated_at: now };
  if (idx >= 0) list[idx] = merged;
  else list.unshift({ ...merged, created_at: now });
  localStorage.setItem(ENCOUNTER_KEY, JSON.stringify(list.slice(0, 50)));
  return merged;
}

export function deleteLocalEncounter(id) {
  const list = loadLocalEncounters().filter((e) => e.id !== id);
  localStorage.setItem(ENCOUNTER_KEY, JSON.stringify(list));
}

// ---------- Custom Foes ----------
export function loadLocalFoes() {
  try {
    const raw = localStorage.getItem(FOE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function saveLocalFoe(foe) {
  const list = loadLocalFoes();
  const now = new Date().toISOString();
  const id = foe.id || `foe_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
  const merged = { ...foe, id, updated_at: now };
  const idx = list.findIndex((f) => f.id === id);
  if (idx >= 0) list[idx] = merged;
  else list.unshift({ ...merged, created_at: now });
  localStorage.setItem(FOE_KEY, JSON.stringify(list.slice(0, 200)));
  return merged;
}

export function deleteLocalFoe(id) {
  const list = loadLocalFoes().filter((f) => f.id !== id);
  localStorage.setItem(FOE_KEY, JSON.stringify(list));
}
